import { z } from 'zod';
import { BaseAuthUserDTOSchema, UserCompanyDTOSchema } from "./auth.dto.js";
// Schema for switch company input
const SwitchCompanyInputDTOSchema = z.object({
    userId: BaseAuthUserDTOSchema.shape.id,
    companyId: UserCompanyDTOSchema.shape.id,
});
// Schema for switch company output
export const SwitchCompanyOutputDTOSchema = z.object({
    companyId: UserCompanyDTOSchema.shape.id,
    companyName: UserCompanyDTOSchema.shape.name,
    companySlug: UserCompanyDTOSchema.shape.slug,
    role: UserCompanyDTOSchema.shape.role,
});
// Request and response schemas for API layer
export const SwitchCompanyRequestDTOSchema = z.object({
    body: SwitchCompanyInputDTOSchema.pick({ companyId: true }),
});
//# sourceMappingURL=switch-company.dto.js.map